/* eslint-disable react/react-in-jsx-scope,react/display-name,react/jsx-no-undef,keyword-spacing */
import React from 'react';
import { browserHistory } from "@common/helpers/browserHistory";
import Config from "@skin_config";
import { t } from "@common/helpers/translator";
import { toast } from "react-toastify";
import Helpers from "@common/helpers/helperFunctions";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";
import toastWrapper from "@common/helpers/toastWrapper";
import { getSelectionsContextValue } from "@common/contexts/selections";
import { broadcast, broadcastChannels } from "@common/helpers/broadcast";
import { PrintTicket } from "@common/actions/terminal";
import { getPreferencesContextValue } from "@common/contexts/preferences";
import { POPUPS } from "@common/constants/popups";
import IdleService from "@common/services/idle";
import { getAuthData } from "@common/helpers/auth";
import { openDeferModal } from '@tickets/helpers/openDeferPopup';
import { checkedTickets, finishLoading, checkCashoutTicket } from "../actions/ui";
import {
  TerminalError,
  LockTerminal,
  UnlockTerminal,
  HideTerminalError,
  SetProfileError,
  SetCurrency,
  ShowKeyboard,
  SetTerminalAuthData,
  HandleMousePosition,
  SetStartupSettings,
  ShowLastBetsList,
  IsAdminLoggedIn,
  RegisterMode,
  IsCardRegistered,
  ClearCardRegistered,
  LoyalCard,
  PrintLotteryTickets,
  SetVerificationInfo,
  ResetVerificationSession,
  setLastMoneyInputType,
  CashoutMoney,
  receiveSavedPlayerPaymentInfo,
  setMerchantId,
} from "../actions/terminal";
import { Logout } from "../actions/login";
import { getCasinoBetsInfo, processBarcode } from "./tickets";
import { getSwarmRfidPinLoginNeededRequest } from "./terminalRequests/rfid";
import { SET_DEPOSIT_MODE } from "../actions/actionTypes";
import { SuccessStatusesEnum } from "../constants/enums/successStatuses";
import { checkForStaffPass } from "../terminal/components/staffLoginPopup";
import { getPopupDispatchers, getPopupState } from "../contexts/popup";
import { registerFromCSharp } from "./registerFromCSharp";
import { updateFromCSharp } from "./updateFromCSharp";
import { checkTerminalMode } from "@common/helpers";
import { appMethods } from "@common/constants/appMethods";
import { FinishCollectDepositMoney } from "../actions/clientTransaction";
import { makeLogin } from './login';
import { logoutUser } from "./verification";
import { TerminalDepositModesEnum } from "../constants/enums/terminalDepositModes";
import PaymentsService from "../services/payments";
import { needToShowOctoInactivePopup } from './okto';
import { TerminalBalanceFetcher } from './terminalBalance';

const initializeAppMethods = () => {
  for (const method of appMethods) {
    if (!window.jsobject[method]) {
      window.jsobject[method] = (...args) => {
        console.log(`Calling method - ${method} with arguments`, args)
      }
    }
  }

  window.jsobject.getNetworkTime = () => {
    window.setNetworkTime(Date.now());
    console.log('getNetworkTime');
  };
};

const setupTerminalFunctionalities = (store) => {
  const currency = Helpers.getUriParam("currency");
  const authData = sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData"));
  if (currency) store.dispatch(SetCurrency(currency));

  const openPopup = (...args) => {
    const { openPopup: openPopupHandler } = getPopupDispatchers();

    openPopupHandler(...args);
  };

  const closePopup = () => {
    const { closePopup: closePopupHandler } = getPopupDispatchers();

    closePopupHandler();
  };

  return new Promise((resolve) => {
    // Functions for app --> (in windows)
    (() => {
      window.jsobject = window.jsobject || window.external || {};
      const noop = () => { };

      window.isFromApp = window.jsobject.setLanguage

      initializeAppMethods()


      if (!window.depositAmount) {
        window.depositAmount = () => {
          console.log("deposit amount");
        };
      }
      window.setInterval(() => {
        if (
          document.activeElement.tagName.toLowerCase() === "a" ||
          document.activeElement.tagName.toLowerCase() === "button"
        ) {
          document.activeElement.blur();
        }
      }, 1000);
      window.onbeforeunload = () => {
        localStorage.removeItem("reduxPersist:favorites");
        localStorage.removeItem("reduxPersist:persistentUIState");
      };
      window.SetToken = (token) => {
        const params = { ...authData };
        params.token = token;
        sessionStorage.setItem("authData", JSON.stringify(params));
        store.dispatch(SetTerminalAuthData({ authData: params }));
      };

      window.emptyBetslip = () => {
        const [, setSelections] = getSelectionsContextValue();
        setSelections((newValue) => ({ ...newValue, events: {} }));
      };

      window.verificationSuccess = (clientId) => { };

      window.setDepositMode = (depositMode) => {
        store.dispatch({
          type: SET_DEPOSIT_MODE,
          depositMode,
        });
      };

      window.tellLastBillsAndCoins = (text) => {
        broadcast.dispatchEvent(new CustomEvent(broadcastChannels.GetLastBills, { detail: text }));
      };

      window.setLanguageFromMainApp = (langCode) => {
        const [preferences, setPreferences] = getPreferencesContextValue();
        setPreferences({ ...preferences, lang: langCode });

        setTimeout(() => window.location.reload(), 0);
      };
      window.cardDepositResult = (response) => {
        if (response.Success) {
          openPopup(POPUPS.SUCCESS_POPUP, {
            title: "Deposit by bank card",
            subTitle: "The transaction was successfully done",
          });
        } else {
          openPopup(POPUPS.ERROR_POPUP, {
            errorMessage: response.Message?.split?.("=> ")[1],
          });
        }
      };

      window.receiveTimestampToken = (token) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.RecieveTimestampToken, { detail: token })
        );
      }

      window.disablePOSInput = (response) => {
        // if (response.Success) {
        //     store.dispatch(OpenPopup('adminScanSuccess', { verificationType: 'rfid' }))
        // } else {
        //     store.dispatch(OpenPopup('errorPopup', { errorMessage: response.Message }))
        // }
      };

      window.openGameDetails = (gameData) => {
        const { popupParams } = store.getState().uiState;
        if (popupParams?.disable) return;

        try {
          if (!navigator.onLine) return;

          const data = JSON.parse(gameData);
          const { sportAlias, regionId, competitionId, gameId } = data;

          browserHistory.push(`/betting/live/${sportAlias}/${regionId}/${competitionId}/${gameId}`);
          console.log("Open game details");
        } catch {
          console.log("Invalid data to open game details");
        }
      };

      window.openCompetitionDetails = (competitionData) => {
        const { popupParams } = store.getState().uiState;
        if (popupParams?.disable) return;

        try {
          const data = JSON.parse(competitionData);
          const { sportAlias, regionId, competitionId } = data;

          browserHistory.push(`/betting/prematch/${sportAlias}/${regionId}/${competitionId}`);
          console.log("Open competition details");
        } catch {
          console.log("Invalid data to open competition details");
        }
      };

      window.setNetworkTime = isoString => {
        broadcast.dispatchEvent(new CustomEvent(broadcastChannels.NetworkTimeChange, { detail: isoString }));
      };

      window.lockScreen = (text) => {
        // const { IsPlayerVerificationEnabled } = store.getState().terminal.startupSettings;
        // if (IsPlayerVerificationEnabled) store.dispatch(EndVerificationSession());
        store.dispatch(LockTerminal(text));
      };
      if (Config.enableTouchPositionIniFrames) {
        window.addEventListener("message", processMessage, false);
        // eslint-disable-next-line no-inner-declarations
        function processMessage(message) {
          if ("data" in message) {
            if (typeof message.data === "string") {
              try {
                const dataJson = JSON.parse(message.data);
                window.jsobject.touchPosition(dataJson.BGTouch.x, dataJson.BGTouch.y);
              } catch (e) { }
            } else if (message.data.type && message.data.type === "BGTouch") {
              try {
                window.jsobject.touchPosition(message.data.position.x, message.data.position.y);
                // eslint-disable-next-line no-empty
              } catch (e) { }
            }
          }
        }
      }
      window.isAdminLoggedIn = (bool) => {
        store.dispatch(IsAdminLoggedIn(bool));

        setTimeout(() => {
          store.dispatch(IsAdminLoggedIn(false));
        }, 20000);
      };
      window.cardRegistered = (params, isSuccess) => {
        registerFromCSharp(params, isSuccess);
      };
      window.cardUpdated = (params, bool) => {
        updateFromCSharp(params, bool);
      };
      window.setProfileError = (text) => {
        store.dispatch(SetProfileError(text));
      };
      window.registerMode = (bool) => {
        store.dispatch(RegisterMode(bool));
      };
      window.clearCardRegistered = () => {
        store.dispatch(ClearCardRegistered());
      };
      window.isCardRegistered = (id, bool) => {
        store.dispatch(IsCardRegistered({ id, bool }));
      };
      window.confirmOnAction = (type, info = "{}") => {
        switch (type) {
          // case "CashoutBetFailed":
          //   // processBarcode(`000${(JSON.parse(info)).barcode}`);
          //   console.log("confirmOnAction");
          //   // toastWrapper("error", "cashout bet failed");
          //   break;
          // case 'EarlyCashoutSucceed':
          //   store.dispatch(OpenPopup('userActionOK', { data: t(Config.textsPopupAfterActions[type]) }));
          //   break;
          case "Cashout":
            broadcast.dispatchEvent(new CustomEvent(broadcastChannels.ReceiveCashoutSuccess, { detail: null }));
            break;
          case "CashoutFinished":
            broadcast.dispatchEvent(new CustomEvent(broadcastChannels.ReceiveCashoutFinished, { detail: null }));
            break;
          case "CnpResult":
            const error = info.split(':');
            if (error[0] === 'Errormessage') {
              toastWrapper('error', error[1]);
              broadcast.dispatchEvent(new CustomEvent(broadcastChannels.GetCnpCheckResult, { detail: null }));
            } else {
              broadcast.dispatchEvent(new CustomEvent(broadcastChannels.GetCnpCheckResult, { detail: info }));
            }
            break;
          case "SuperBetAccepted":
            openPopup(POPUPS.SUPERBET, {
              disable: true,
              superBetIsAlreadyAccepted: true,
            });
            break;
          case "SuperBetRejected":
            openPopup(POPUPS.SUPERBET, {
              disable: true,
              superBetIsAlreadyAccepted: false,
            });
            break;
          case "BetNotFound":
            store.dispatch(TerminalError(t("Bet not found")));
            break;
          case "TicketNotFound":
            store.dispatch(TerminalError(t("Ticket not found")));
            break;
          case "NotAllowed":
            store.dispatch(TerminalError(t("Not allowed")));
            break;
          case "DepositToClientAccount":
            openPopup(POPUPS.SUCCESS_POPUP, {
              title: "Transfer to Account",
              subTitle: "The transfer was successfully done.\nPlease take your ticket",
            });

            break;
          case "CashoutWithFeeSucceed":
            openPopup(POPUPS.SUCCESS_POPUP, {
              title: "Cash Out",
              subTitle: "Cash out was successfully done.\nPlease take your ticket",
            });

            break;
          default:
            // Config.showPopupAfterActions && store.dispatch(OpenPopup('userActionOK', { data: t(Config.textsPopupAfterActions[type]) }));
            break;
        }
      };
      window.testMethod = () => {
        const obj = [{ igor: true }, { arman: true }, { sahak: false }];
        const promise = new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(obj);
          }, 5000);
        });
        promise.then((val) => {
          val;
        });
        return promise;
      };
      window.testMethod2 = () => {
        const obj = [{ igor: true }, { arman: true }, { sahak: false }];
        return obj;
      };
      window.bulkTitoOperationResult = (data) => {
        store.dispatch(checkedTickets(data));
      };
      window.bulkTitoOperationCustomResult = (data) => {
        console.log("custom result of pay ticket");
        if (!data.Result.Succeeded) {
          broadcast.dispatchEvent(
            new CustomEvent(broadcastChannels.TitoOperationResult, {
              detail: data,
              hasError: true,
            })
          );
        } else {
          broadcast.dispatchEvent(
            new CustomEvent(broadcastChannels.TitoOperationResult, {
              detail: data,
            }),
          );
        }
      };
      window.bulkTitoOperationComplited = (bool) => {
        store.dispatch(finishLoading(bool));
      };
      window.earlyCashoutResult = async (data) => {
        try {
          // In case when data.Data is a JSON

          const result = JSON.parse(data.Data);
          data.Data = result;
          // if (typeof result === "object") {
          broadcast.dispatchEvent(
            new CustomEvent(broadcastChannels.EarlyCashoutResult, {
              detail: { success: data.Succeeded, message: data.Message },
            })
          );
          // }
        } catch {
          broadcast.dispatchEvent(
            new CustomEvent(broadcastChannels.EarlyCashoutResult, {
              detail: { success: data.Succeeded && data.Data !== "CashoutBetFailed", message: data.Message },
            })
          );
        }

        store.dispatch(checkCashoutTicket(data));

        // } else if (cashoutTicketBarcode) {
        // 	const result = await getTicketData(cashoutTicketBarcode);
        // 	const type = "sport";
        // 	const tickets = getTicketsState();
        // 	const setTickets = getTicketsDispatcher();
        // 	const cashoutTicketIndex = tickets.sport.findIndex(
        // 		item => item?.dataFromSwarm?.barcode === +cashoutTicketBarcode
        // 	);
        //
        // 	if (!Config.main.enableTicketTimer && result.dataFromSwarm.paid_date) {
        // 		setTimeout(() => {
        // 			setTickets((newTickets) => ({
        // 				[type]: newTickets[type].filter(
        // 					(item) =>
        // 						(item.barcode
        // 							|| item.dataFromSwarm?.barcode)
        // 						!== +cashoutTicketBarcode,
        // 				),
        // 			}));
        // 		}, Config.main.showTicketAfterPay);
        // 	}
        //
        // 	store.dispatch(checkCashoutTicket(null));
        //
        // 	if (~cashoutTicketIndex) {
        // 		if (!Config.main.enableTicketTimer) {
        // 			setTickets((newTickets) => ({
        // 				...newTickets,
        // 				[type]: [
        // 					...newTickets[type].slice(
        // 						0,
        // 						cashoutTicketIndex,
        // 					),
        // 					result,
        // 					...newTickets[type].slice(
        // 						cashoutTicketIndex + 1,
        // 					),
        // 				],
        // 			}));
        // 		} else {
        // 			setTickets((newTickets) => {
        // 				const updatedTickets = [...newTickets[type]];
        // 				updatedTickets[cashoutTicketIndex] = { ...result };
        //
        // 				return {
        // 					...newTickets,
        // 					[type]: updatedTickets,
        // 				};
        // 			});
        // 		}
        // 	}
        //
        // 	toastWrapper("success", "Successfully Cashout");
        // }
      };

      window.receivePlayerInfo = (data) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.ReceivePlayerInfo, {
            detail: JSON.parse(data),
          })
        );
      };

      window.receivePlayerMaxDepositAmount = (data) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.ReceivePlayerMaxDepositAmount, {
            detail: typeof data === "string" ? data : JSON.parse(data),
          })
        );
      };

      window.receiveCollectedAmount = (amount) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.ReceiveCollectedAmount, {
            detail: amount,
          })
        );
      };

      window.receiveDepositTickets = (data) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.ReceiveDepositTickets, {
            detail: JSON.parse(data),
          })
        );
      };

      window.receiveWithdrawalRequests = (data) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.ReceiveWithdrawalRequests, {
            detail: JSON.parse(data),
          })
        );
      };

      window.receiveIsWithdrawalPinValid = (isValid) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.ReceiveIsWithdrawalPinValid, {
            detail: JSON.parse(isValid),
          })
        );
      };

      window.receiveIsWithdrawalState = (isSuccess) => {
        broadcast.dispatchEvent(
          new CustomEvent(broadcastChannels.ReceiveIsWithdrawalState, {
            detail: JSON.parse(isSuccess),
          })
        );
      };

      window.openIdleTimePopup = () => {
        const terminalState = store.getState().terminal;
        const isLocked = terminalState.popupLauncher?.lockTerminal;
        const activePopup = getPopupState()[0] || {};
        const { type: popupType } = activePopup;

        if (popupType?.toString() === 'CLIENT_DEPOSIT_POPUP') {
          console.log("Deposit popup is opened - skip inactivity popup");
          return;
        }

        if (isLocked) return;

        if (Config.popupForTerminalInactivity) {
          const inactivePopup = needToShowOctoInactivePopup() ? POPUPS.NON_CASH_INACTIVE_POPUP : POPUPS.INACTIVE_TERMINAL

          // auto cashout case without inactivity popup

          // if ((TerminalDepositModesEnum.Octo || playerInfo?.PersonalId) && terminalBalance > 5) {
          //   // Deposit ticket okto > 5 case

          //   store.dispatch(CashoutMoney(null));
          //   // dispatch({ type: RESET_UI_BY_IDLE_TIMER });
          //   setTimeout(() => {
          //     PaymentsService.clearSessionBalanceState();
          //   }, 1000);

          //   return;
          // }


          // simple check

          // const inactivePopup =
          //   depositMode === TerminalDepositModesEnum.Octo ? POPUPS.NON_CASH_INACTIVE_POPUP : POPUPS.INACTIVE_TERMINAL;

          openPopup(inactivePopup);
        } else {
          console.log("PopupForTerminalInactivity is disabled");
        }
      };
      window.terminalLockReminder = (data) => {
        if (Config.popupForTerminalLock) {
          openPopup(POPUPS.TERMINAL_LOCK_REMINDER, { data });
        } else {
          console.log("PopupForTerminalLock is disabled");
        }
      };
      window.unlockScreen = () => {
        toast.dismiss("fixed-message");

        store.dispatch(UnlockTerminal(null));
      };
      window.hideTerminalError = () => {
        store.dispatch(HideTerminalError(null));
      };
      window.touchInput = () => IdleService.resetTimer();
      window.keyboardInput = () => IdleService.resetTimer();
      window.getLotteryTicketInfoByExternalId = async (ExternalId) => {
        const isCopy = true;

        const [casinoData, swarmData] = await Promise.all([
          getCasinoBetsInfo(Config, [ExternalId]),

          swarmRequest(
            {
              CashdeskId: JSON.parse(sessionStorage.getItem("authData")).tid,
              token: JSON.parse(sessionStorage.getItem("authData")).token,
              ExternalId,
              IsWithAdditionalInfo: true,
            },
            "terminal_get_casino_bets"
          ),
        ]);

        const ticketInfo = casinoData.Data[0];
        if (!ticketInfo || !swarmData.Data[0]) {
          return store.dispatch(TerminalError(t("Bet not found")));
        }

        swarmData.Data[0].possible_tax_amount = ticketInfo.PossibleTaxAmount;
        store.dispatch(PrintLotteryTickets(JSON.stringify(swarmData.Data[0]), isCopy));
      };
      window.forceLogout = () => {
        store.dispatch(LoyalCard(null));
        const storeState = store.getState();
        const loggedIn = storeState.user && storeState.user.loggedIn;
        if (loggedIn) {
          store.dispatch(Logout());
        }
      };
      window.getLastMoneyInputType = () => {
        TerminalBalanceFetcher.debouncedFetchAndStore();
        TerminalBalanceFetcher.enablePolling();
      }; // empty function for not having error

      window.cashMoneyInserted = () => {
        TerminalBalanceFetcher.debouncedFetchAndStore();
        TerminalBalanceFetcher.enablePolling();
      };

      window.OpenAdminLogin = () => {
        openPopup(POPUPS.LOGIN_FORM, { signInToAdmin: true, popupPosition: 'top' });
      };
      window.receiveSavedPlayerPaymentInfo = (playerInfo) => {
        store.dispatch(receiveSavedPlayerPaymentInfo(JSON.parse(playerInfo)));
      };
      window.showTerminalError = (error, close) => {
        store.dispatch(TerminalError({ error, close }));
      };
      window.showLastBetsList = (tickets) => {
        store.dispatch(ShowLastBetsList(tickets));
      };
      window.verificationPending = () => openPopup(POPUPS.PASSPORT_VERIFICATION_LOADING);
      window.openAdminPage = (restrictedMode = Config.main.adminDefaultRestricted) => {
        const state = store.getState();
        const { isAdminPageBlocked } = state.terminal;

        if (isAdminPageBlocked) return;

        window.jsobject.adminPageWasOpened();

        const path = restrictedMode ? "/admin?restrictedMode=true" : "/admin";
        browserHistory.push(path);
        closePopup();
      };
      window.isMainPage = () => {
        if (window.location.pathname === "/" && !needToShowOctoInactivePopup()) {
          return true;
        }
        return false;
      };
      window.confirmAction = (actionType) => {
        switch (actionType) {
          case SuccessStatusesEnum.CashoutWithFeeSucceed:
            openPopup(POPUPS.SUCCESS_POPUP, {
              title: "Cash Out",
              subTitle: "Cash out was successfully done.\nPlease take your ticket",
            });
            break;
          case SuccessStatusesEnum.default:
        }
      };
      window.resetVerification = () => {
        store.dispatch(ResetVerificationSession());
      };
      window.verificationSuccess = (clientId) => {
        store.dispatch(SetVerificationInfo({ clientId: +clientId }));
        openPopup(POPUPS.PASSPORT_VERIFICATION_SUCCESS);
      };
      window.paymentPopupState = (bool) => {
        const action = bool ? openPopup : closePopup;
        action(POPUPS.SHOW_PAYMENT_POPUP, { disable: true });
      };
      window.tellUILastPaidTicketsCount = (count) => {
        // not handle for this popup
        // store.dispatch(OpenPopup('adminPayedTicketsCount', { count }));
      };

      window.showUIToast = (type, message, messageType) => {
        toastWrapper(type, message, "Main-Toastify", messageType);
      };
      window.receiveBetPaymentInfos = (data) => {
        try {
          broadcast.dispatchEvent(
            new CustomEvent(broadcastChannels.ReceiveBetPaymentInfos, { detail: JSON.parse(data) })
          );
        } catch (ex) {
          console.log("Error while trying to parse bet payment infos");
        }
      };

      window.SignInByRFID = async (rfid) => {
        if (!rfid)
          return toastWrapper("error", "Invalid credentials");

        const { tid } = JSON.parse(sessionStorage.getItem("authData"));
        const state = store.getState();
        const scanBarcode =
          !(state.uiState.popupParams !== undefined) ||
          !(state.uiState.popupParams !== null) ||
          !state.uiState.popupParams.disable;

        if (!state.user.loggedInByRFID) {
          if (Config.main.rfidPinCode) {
            const pinNeededResult = await swarmRequest(
              getSwarmRfidPinLoginNeededRequest({ Rfid: rfid }),
              "betshop_command"
            );
            if (pinNeededResult?.data?.IsNeeded) return openPopup(POPUPS.LOGIN_BY_PIN_CODE, { rfid });
          }

          swarmRequest(
            {
              card_number: rfid,
              cashdesk: tid,
            },
            "rfid_login"
          )
            .then((data) => {
              if (!data) throw new Error("Something went wrong");
              if (!data.user_id) {
                return toastWrapper("error", data.details || "Invalid credentials");
              }

              makeLogin({ authData: data, rfid, loggedInByRFID: true });

              Config.rfid.logoutIfIdleSecondsCount &&
                IdleService.ifInactive(Config.rfid.logoutIfIdleSecondsCount, () => {
                  store.dispatch(Logout(true));
                  closePopup();
                });
            })
            .catch((err) => {
              openPopup(POPUPS.ERROR_LOGGED_IN_RFID, {
                text: "Invalid RFID card",
              });
            });
        } else if (scanBarcode) {
          openPopup(POPUPS.ERROR_LOGGED_IN_RFID, {
            text: "Sorry, but you can't open new session before closing the previous one",
          });
        }
      };
      window.SignOutRF = () => {
        store.dispatch(Logout());
      };
      window.openMainPage = () => {
        console.info("Open main page");
      };
      window.barcodeEnter = (barcode) => {
        const inLockedState = store.getState().terminal.popupLauncher?.lockTerminal;
        const terminalUsageConfirmed = (
          !Config.main.enableTerminalUsageConfirmation
          || store.getState().terminal.terminalUsageConfirmed
        );

        if (terminalUsageConfirmed && !inLockedState && checkTerminalMode(Config, "betting")) {
          processBarcode(barcode);
        }
      };
      window.getLanguage = noop;

      broadcast.addEventListener(broadcastChannels.PrintTicket, (e) => {
        store.dispatch(PrintTicket(JSON.stringify(e.detail)));
      });

      window.clearMoneyInputState = () => {
        const state = store.getState();
        const { depositMode } = state.terminal;

        if ([TerminalDepositModesEnum.Ticket, TerminalDepositModesEnum.Cash].includes(depositMode)) return;
        // if (depositMode === TerminalDepositModesEnum.Ticket) return;

        // const terminalBalance = GetTerminalBalance(state);

        // if (
        //   (depositMode === TerminalDepositModes.Cash &&
        //     terminalBalance <= Config.main.minAutoCashoutAmount) ||
        //   depositMode === TerminalDepositModes.OKTO && terminalBalance !== 0
        // )
        //   store.dispatch(CashoutMoney());

        PaymentsService.clearSessionBalanceState();
        store.dispatch(setLastMoneyInputType(TerminalDepositModesEnum.Ticket)); // old cash
      };

      window.setStartupSettings = (settings) => {
        store.dispatch(SetStartupSettings(settings));
      };

      window.setMinMax = (min, max) => {
        store.dispatch(SetStartupSettings({ MinBet: min, MaxBet: max }));
      };

      window.getAdminUserBarcodeResponse = (response) => {
        if (response.Success) {
          window.openAdminPage(true);
        } else {
          const errorMessage = response.Code === 11003 ? "Admin is not found" : response.Message;

          toastWrapper("error", errorMessage);
        }
      };
    })();

    window.receiveMerchantInfo = (data) => {
      const { betshopid } = authData || {};
      const merchantInfo = JSON.parse(data);

      let merchantId = merchantInfo.defaultMerchantId;
      const betshopMerchant = merchantInfo.betshopMerchantInfos.find((item) => +item.betshopId === +betshopid);

      if (betshopMerchant) merchantId = betshopMerchant.merchantId;

      store.dispatch(setMerchantId(merchantId));
    };

    const reloadApp = () => {
      window.jsobject.reload();
      Config.main.terminalMode === "clientTransaction" && store.dispatch(FinishCollectDepositMoney());
    };

    // Event listeners

    (() => {
      window.barcodeBuffer = [];
      window.addEventListener("mousedown", (e) => {
        Config.main.enableFunctionalitySetMousePosition &&
          store.dispatch(HandleMousePosition({ x: e.screenX, y: e.screenY }));
      });

      // on external iframe click window is beeing blured, for such cases we added this handler also:)
      // window.addEventListener('blur', () => {
      //     if (document.activeElement.tagName === "IFRAME") {
      //         Config.main.enableFunctionalitySetMousePosition && store.dispatch(HandleMousePosition({ x: 0, y: 0 }));
      //         setTimeout(window.focus, 0);
      //     }
      // });

      window.addEventListener(
        "contextmenu",
        (window) => {
          window.preventDefault();
        },
        false
      );
      window.addEventListener("keydown", async (e) => {
        // alt + z
        if (e.altKey && e.keyCode === 79) {
          const token = getAuthData()?.token;
          // const sessionBalanceResponse = await swarmRequest({ token }, "terminal_get_session_balance_state");
          const sessionBalanceResponse = await swarmRequest(
            {
              name: "GetSessionBalanceState",
              params: { Token: token },
            },
            "terminal_command"
          );

          if (sessionBalanceResponse.data) {
            alert(
              `${Object.keys(sessionBalanceResponse.data).map(
                (key) => `${key.replace(",", "")} - ${sessionBalanceResponse.data[key]}\n`
              )}`
            );
          }
        }
        if (e.altKey && e.keyCode === 90) {
          const accepted = await checkForStaffPass();

          if (accepted) window.clearMoneyInputState();
        }
        if (e.altKey && e.keyCode === 82) {
          // alt+r
          reloadApp();
        } else if (e.altKey && e.keyCode === 73) {
          // alt+i
          const accepted = await checkForStaffPass();
          accepted && window.jsobject.inspectElement();
        } else if (e.altKey && e.keyCode === 65) {
          // alt+a
          const accepted = await checkForStaffPass();
          if (Config.AdminShortcutWithLoginOnly) {
            openPopup(POPUPS.LOGIN_FORM, { signInToAdmin: true, popupPosition: 'top' });
          } else if (accepted) {
            window.openAdminPage(false);
          }
        } else if (e.altKey && e.keyCode === 76) {
          // alt+l
          const accepted = await checkForStaffPass();
          accepted && window.jsobject.openLastLogFile();
        } else if (e.altKey && e.keyCode === 84) {
          // alt+t
          const accepted = await checkForStaffPass();
          accepted && window.jsobject.openTerminalIdDialog();
        } else if (e.altKey && e.keyCode === 67) {
          // alt+c
          window.jsobject.openDmsLastTicketDialog();
        } else if (e.altKey && e.keyCode === 81) {
          // alt+q
          window.isAdminLoggedIn(1);
        } else if (e.altKey && e.keyCode === 75) {
          // alt + k
          window.killSwarm();
        } else if (e.altKey && e.keyCode === 78) {
          const state = store.getState();
          alert(state.terminal.depositMode);
        } else if (!e.altKey && e.key === 'r' && Config.enableKeypressCashout) {
          const terminalBalance = store.getState().terminal.balance?.session_balance;
          if (terminalBalance) openPopup(POPUPS.CASHOUT);
        }
      });

      // old check !Config.main.disableKeyboardBarcodeCatch && checkTerminalMode(Config, "betting")
      if (!window.jsobject.setLanguage || Config.main.enableKeyboardCatching) {
        window.addEventListener('keypress', (e) => {
          const inLockedState = store.getState().uiState.popupParams?.disable;
          const terminalUsageConfirmed = (
            !Config.main.enableTerminalUsageConfirmation
            || store.getState().terminal.terminalUsageConfirmed
          );

          if (terminalUsageConfirmed && !inLockedState) {
            if (+e.which !== 13) {
              clearTimeout(window.barcodeBufferTimer);
              window.barcodeBuffer.push(e.key);
              window.barcodeBufferTimer = setTimeout(() => {
                window.barcodeBuffer = [];
                window.barcodeBufferTimer = null;
              }, 2000);
            }
            if (+e.which === 13) {
              const { barcodeBuffer } = window;
              let result = "";
              for (let i = 0; i < barcodeBuffer.length; i++) {
                result += barcodeBuffer[i];
              }
              processBarcode(result);
            }
          }
        });
      }

      if (!window.jsobject.setLanguage) {
        window.jsobject.setLanguage = (language) => {
          console.log("setLanguage", language);
        };
      }

      window.addEventListener(
        "message",
        (event) => {
          const { action } = event.data;
          if (action === "openKeyboard") {
            window.liveCasinoEventSource = event.source;
            store.dispatch(ShowKeyboard(false));
            store.dispatch(ShowKeyboard(true));
          }
        },
        false
      );
      const oldOnError = window.onerror;
      window.onerror = function () {
        if (oldOnError) {
          oldOnError.apply(this, arguments);
          // store.dispatch(SendLogs({msg, url, lineNo, columnNo, error: JSON.stringify(error)}));
        }
      };
    })();

    resolve();
  });
};

export default setupTerminalFunctionalities;
